module.exports = __webpack_public_path__ + "static/img/beachball.b4c9813.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/beachball.png
// module id = URlc
// module chunks = 0